import get from 'lodash/get'

export function isProductDiscounted (productPriceData) {
  return !!get(productPriceData, 'discountAmount')
}

export function getLatestPrice (productPriceData, showDiscounts) {
  const currentPrice = get(productPriceData, 'sellprice')

  if (!isProductDiscounted(productPriceData) || !showDiscounts) {
    return currentPrice
  }

  const discountAmount = get(productPriceData, 'discountAmount')
  const discountedPrice = currentPrice - discountAmount

  return {
    originalPrice: currentPrice,
    valueOf: () => discountedPrice
  }
}
